import { useEffect, useState } from 'react';
import api from './api';

export const useSlotImage = (slot, fallback) => {
  const [src, setSrc] = useState(fallback);
  useEffect(() => {
    api.get(`/site-photos/${slot}`)
      .then(({ data }) => { if (data.images?.length) setSrc(data.images[0]); })
      .catch(() => {});
  }, [slot]);
  return src;
};
